import Config from '@/shared/Config'
import _get from 'lodash/get'
import Vue from 'vue'
export default {
  state: {
    socketId: null
  },
  mutations: {
    SET_SOCKET_ID (state, socketId) { // Not WS
      state.socketId = socketId
    }
  },
  actions: {
    async WEBSOCKET_LOAD ({ commit }, name) {
      const config = await Config()
      if (_get(config, `WS.${name}`)) {
        const filterEvents = _get(config, `WS.${name}.events`, null)
        const onEvent = (event) => {
          if (filterEvents && !filterEvents.includes(event.type)) return
          const actionName = event.type.toUpperCase().replace(/\./g, '_')
          event.data.__socketId = event.fpsocketid
          commit(actionName, event.data)
        }
        const onConnect = (_) => {
          Vue.WebSockets.send(name, {
            method: 'subscribe',
            data: {
              channel: 'events'
            }
          })
          // That kind of event will launch store dispatch
          Vue.WebSockets.unsubscribe(`${name.toLowerCase()}-event`, onEvent)
          Vue.WebSockets.subscribe(`${name.toLowerCase()}-event`, onEvent)
        }
        await Vue.WebSockets.init(name, onConnect)
      }
    },

    async WEBSOCKET_INIT ({ dispatch }) {
      dispatch('WEBSOCKET_LOAD', 'DPE')
      dispatch('WEBSOCKET_LOAD', 'IAM')
      dispatch('WEBSOCKET_LOAD', 'ML')
      dispatch('WEBSOCKET_LOAD', 'DWH')
      dispatch('WEBSOCKET_LOAD', 'EVENT_MANAGER')
    },

    async WEBSOCKET_CLOSE () {
      Vue.WebSockets.close()
    }
  },
  getters: {
    SOCKET_ID (state) {
      return state.socketId
    }
  }
}
